<ls-dynamic-table [sortAsc]="false"
                   currentSort="beginDate"
                   [data]="events | async"
                   [headers]="tableaHeaders"
                   [actions]="tableActions">
  <ng-template let-item>
    <td class="d-none d-md-table-cell">
      <app-badge [label]="{id: 0, name: item.type, backcolor: '#2C6D9F', textcolor: '#FFFFFF'}"></app-badge>
    </td>
    <td class="d-none d-md-table-cell">
      {{item.title}}
    </td>
    <th scope="row" class="d-table-cell d-md-none">
      <app-badge [label]="{id: 0, name: item.type, backcolor: '#2C6D9F', textcolor: '#FFFFFF'}"></app-badge> {{item.title}}
    </th>
    <td>
      <span class="d-inline d-md-none">Pour : </span>
      @for(c of item.categories; track c) {
        <app-badge [label]="c"></app-badge>
      }
    </td>
    <td>
      <span class="d-inline d-md-none">Date de début : </span>
      {{item.beginDate | date:'dd/MM/yyyy'}}
    </td>
    <td>
      <span class="d-inline d-md-none">Date de fin : </span>
      {{item.endDate | date:'dd/MM/yyyy'}}
    </td>
    <td>
      @if(isVisible(item)) {
        <fa-icon class="text-success" icon="check"></fa-icon>
        <span class="d-inline-block d-md-none text-success">&nbsp;Visible</span>
      } @else {
        <fa-icon class="text-danger" icon="times"></fa-icon>
        <span class="d-inline-block d-md-none text-danger">&nbsp;Non visible</span>
      }
    </td>
  </ng-template>
</ls-dynamic-table>
